/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationDetailsTabcontrolAliases {
  FRAGMENT_ATTACHMENTS = 'fragment-attachments',
  FRAGMENT_HISTORY = 'fragment-history',
  FRAGMENT_NEGOTIATION = 'fragment-negotiation',
  PANEL_NEGOTIATION_DETAILS_TABCONTROL = 'panel-negotiation-details-tabcontrol',
  TAB_ATTACHMENTS = 'tab-attachments',
  TAB_CONTROL_0 = 'tab-control-0',
  TAB_HISTORY = 'tab-history',
  TAB_NEGOTIATION = 'tab-negotiation',
}
export { NegotiationDetailsTabcontrolAliases };
